import { Component, inject, effect, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RendererDirective } from '../../core/dynamic/renderer';
import { StyleHelper } from '../../general';
import { FilmSignal } from '../../signal';

@Component({
    selector: 'app-film',
    imports: [CommonModule, RendererDirective],
    templateUrl: './film.component.html',
    styleUrls: ['./film.component.scss']
})
export class FilmComponent {
    private readonly styleHelper = inject(StyleHelper);
    private readonly filmSignal = inject(FilmSignal);

    data = computed(() => this.filmSignal.open());
    style = computed(() => {
        const data = this.data();
        return data?.model?.style ? this.styleHelper.parse(data.model.style) : null;
    });
    hidden = signal<boolean>(true);

    constructor() {

        effect(() => {
            const data = this.data();
            if (!data) {
                this.hidden.set(true);
                return;
            }

            this.hidden.set(false);
        });
    }

    onClose() {
        this.filmSignal.open.set(undefined);
    }

    onStop(event: PointerEvent) {
        event.stopPropagation();
    }
}
